/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { Button, ModalActions, StyledModal } from 'sarsaparilla';
import { RecaptchaCheckbox } from 'shared-ui/recaptcha';

/**
 * v2 reCAPTCHA checkbox fallback modal for the site pass add-to-cart flow.
 *
 * Rendered when the backend requests an additional challenge while creating a
 * site pass reservation from within timed entry. Solving the checkbox and
 * clicking Continue re-submits the reservation with a V2 token.
 */
export function SitePassRecaptchaModal({
    isOpen,
    recaptchaCheckboxProps,
    isV2Invalid,
    onContinue,
}) {
    if (!isOpen) return null;

    return (
        <StyledModal
            isOpen={isOpen}
            heading="We need to verify that you're a human"
            shouldCloseOnOverlayClick={false}
            shouldShowCloseButton={false}
        >
            <RecaptchaCheckbox
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...recaptchaCheckboxProps}
                isFallbackOnly
                action="create_sitepass_reservation"
            />
            <ModalActions>
                <Button
                    onClick={onContinue}
                    isDisabled={isV2Invalid}
                    gaTrackingId="sitepass-recaptcha-submit"
                    appearance="tertiary"
                >
                    Continue Booking
                </Button>
            </ModalActions>
        </StyledModal>
    );
}

SitePassRecaptchaModal.propTypes = {
    isOpen: PropTypes.bool,
    recaptchaCheckboxProps: PropTypes.object,
    isV2Invalid: PropTypes.bool,
    onContinue: PropTypes.func,
};

export default SitePassRecaptchaModal;
